import type { HTMLAttributes, ReactNode } from 'react'
import { CircleAlert, CircleCheck, Info, TriangleAlert, X } from 'lucide-react'
import styles from './Callout.module.css'

export type CalloutVariant = 'default' | 'info' | 'success' | 'warning' | 'error'

const variantIcons: Record<CalloutVariant, ReactNode> = {
  default: <Info size={16} />,
  info: <Info size={16} />,
  success: <CircleCheck size={16} />,
  warning: <TriangleAlert size={16} />,
  error: <CircleAlert size={16} />,
}

export interface CalloutProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CalloutVariant
  icon?: ReactNode | true
  onDismiss?: () => void
}

export function Callout({ variant = 'default', className, children, icon, onDismiss, ...props }: CalloutProps) {
  const classes = [
    styles.callout,
    styles[variant],
    className,
  ].filter(Boolean).join(' ')

  const resolvedIcon = icon === true ? variantIcons[variant] : icon

  return (
    <div role="note" className={classes} {...props}>
      {resolvedIcon && <span className={styles.icon}>{resolvedIcon}</span>}
      <div className={styles.content}>{children}</div>
      {onDismiss && (
        <button
          type="button"
          className={styles.dismiss}
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
